<template>
  <section class="m-guided-checkout-step">
    <div class="m-guided-checkout-step__header">
      <span class="m-guided-checkout-step__number">{{ stepNumber }}</span>
      <div>
        <h2 class="m-guided-checkout-step__title">
          {{ title }}
        </h2>
        <p
          v-if="description"
          class="m-guided-checkout-step__description"
        >
          {{ description }}
        </p>
      </div>
    </div>

    <div class="m-guided-checkout-step__content">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'MGuidedCheckoutStep',
  props: {
    stepNumber: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.m-guided-checkout-step {
  &__header {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  &__number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: var(--c-primary);
    color: var(--c-white);
    font-weight: 700;
    flex-shrink: 0;
  }

  &__title {
    margin: 0;
    font-size: 1.5rem;
    line-height: 1.3;
  }

  &__description {
    margin: 0.35rem 0 0;
    color: var(--c-dark-variant);
    line-height: 1.4;
  }
}
</style>
